import React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';

import AppMenu from '../psuite-js/components/mui/AppMenu';
import AccountPopMenu from '../psuite-js/components/mui/AccountPopMenu';

import { observer, inject } from 'mobx-react';

const Header = ({ document_store, app_store }) => {

    const syncData = () => {
        document_store.fetch({ filter: { status: document_store.active_section } });
    }

    return (
        <AppBar position="fixed" classes={{root: 'appbar'}}>
            <Toolbar className="toolbar">
                <IconButton color="inherit" onClick={app_store.toggleMenu}>
                    <i className="material-icons">menu</i>
                </IconButton>

                <div className="title" onClick={syncData}>
                    <Typography type="title" color="inherit">
                        <div>Delivery</div>
                    </Typography>
                </div>

                <div className="app-action-buttons">
                    <IconButton color="inherit" onClick={syncData}>
                        <i className="material-icons">sync</i>
                    </IconButton>

                    <AppMenu />
                    <AccountPopMenu />
                </div>
            </Toolbar>
        </AppBar>
    );

}

let container = observer(Header);
container = inject(['document_store'])(container);
container = inject(['app_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/Header.js